import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ca4a4c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增会员福利")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("送礼品")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("送工位")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("优惠券")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("加友权限")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("服务")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "会员福利" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.addApply
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'type')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.type == '1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "送礼品"))
                    : _createCommentVNode("", true),
                  (record.type == '2')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "送工位"))
                    : _createCommentVNode("", true),
                  (record.type == '3')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, "优惠券"))
                    : _createCommentVNode("", true),
                  (record.type == '4')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "加友权限"))
                    : _createCommentVNode("", true),
                  (record.type == '5')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "服务"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'level' )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.level == null ? '暂无等级' : record.level.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'vipWelfara' )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (record.type == 1 && record.good !==null )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record.good.name) + "*" + _toDisplayString(record.count), 1))
                    : _createCommentVNode("", true),
                  (record.type == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "送工位 * " + _toDisplayString(record.count), 1))
                    : _createCommentVNode("", true),
                  (record.type == 3 && record.coupon !==null )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(record.coupon.name) + "* " + _toDisplayString(record.count), 1))
                    : _createCommentVNode("", true),
                  (record.type == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "加友权限 * " + _toDisplayString(record.count), 1))
                    : _createCommentVNode("", true),
                  (record.type == 5 && record.service !==null )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(record.service.title) + "* " + _toDisplayString(record.count), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该数据?",
                    onConfirm: ($event: any) => ($setup.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[8] || (_cache[8] = ($event: any) => ($setup.onSubmit('formRef'))),
      width: "25%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: $setup.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "福利名称",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                  placeholder: "请输入福利名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "用户等级",
              name: "user_level_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.formState.user_level_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.user_level_id) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择用户等级"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "福利类型",
              name: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.formState.type,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.type) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择福利类型",
                  onChange: $setup.changeType
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 3 }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 4 }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 5 }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.formState.type == 1 )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "商品",
                  name: "goods_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      onPopupScroll: $setup.popupScroll,
                      onSearch: $setup.handleChange2,
                      "show-search": "",
                      name: "type",
                      ref: "select",
                      value: _ctx.formState.goods_id,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.goods_id) = $event)),
                      placeholder: "请选择商品",
                      "filter-option": _ctx.filterOption,
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.name + index,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name) + "(" + _toDisplayString(item.shop_name) + ")（" + _toDisplayString(item.id) + "） ", 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["onPopupScroll", "onSearch", "value", "filter-option"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formState.type == 3 )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "优惠券",
                  name: "coupon_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.formState.coupon_id,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.coupon_id) = $event)),
                      style: {"width":"100%"},
                      placeholder: "请选择优惠券"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupleList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formState.type !== undefined )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 2,
                  label: "数量",
                  name: "count"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.count,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.count) = $event)),
                      placeholder: "请输入数量"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formState.type == 5 )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 3,
                  label: "关联文章",
                  name: "article_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.formState.article_id,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.article_id) = $event)),
                      style: {"width":"100%"},
                      placeholder: "请选择关联文章"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artData, (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}